import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '../../shared/module/angular-material.module';
import { BulkPartAddDialogComponent } from './bulk-part-add-dialog.component';
import { VehicleGridModule } from 'src/app/fleet/vehicle-grid/vehicle-grid.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [BulkPartAddDialogComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    VehicleGridModule,
    TranslateModule
  ],
  exports: [BulkPartAddDialogComponent]
})
export class BulkPartAddDialogModule { }
